/**
 * The namespace for the LoadingIndicator component.
 */
export namespace LoadingIndicatorTypes {
    /**
     * An enumeration containing all possible loading indicator sizes.
     */
    export enum IndicatorSize {
        /**
         * Small sized loading indicator.
         */
        SMALL = 24,
        /**
         * Medium sized loading indicator.
         */
        MEDIUM = 36,
        /**
         * Large sized loading indicator.
         */
        LARGE = 48,
    }
    /**
     * An enumeration containing all possible loading indicator label sizes.
     */
    export enum LabelSize {
        /**
         * Small sized loading indicator label font.
         */
        SMALL = "loading-indicator-label-small",
        /**
         * Medium sized loading indicator label font.
         */
        MEDIUM = "loading-indicator-label-medium",
        /**
         * Large sized loading indicator label font.
         */
        LARGE = "loading-indicator-label-large",
    }
}
